// The Research tab now surfaces only the Certificate of Analysis library.
// All prior educational articles were removed at the request of the operator
// (RUO / Stripe compliance — keep the public site strictly to product documentation).
import CoaLibrary from "./CoaLibrary";

export default function ResearchCenter() {
    return <CoaLibrary />;
}
